import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GroupsPermissionsComponent } from './groups-permissions.component';
import { ManagementGroupsComponent } from './management-groups/management-groups.component';
import { ManagementGroupsProcessComponent } from './management-groups-process/management-groups-process.component';
import {
  ManagementGroupsPermissionComponent
} from './management-groups-permission/management-groups-permission.component';
import { SharedAdministrationModule } from '../shared-administration/shared-administration.module';

@NgModule({
  imports: [
    CommonModule,
    SharedAdministrationModule
  ],
  declarations: [
    GroupsPermissionsComponent,
    ManagementGroupsComponent,
    ManagementGroupsProcessComponent,
    ManagementGroupsPermissionComponent
  ]
})
export class GroupsPermissionsModule { }



// WEBPACK FOOTER //
// ./src/app/administration/groups-permissions/groups-permissions.module.ts